import { render, staticRenderFns } from "./VideoWithChaptersView.vue?vue&type=template&id=98b0ff50&scoped=true"
import script from "./VideoWithChaptersView.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoWithChaptersView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./VideoWithChaptersView.vue?vue&type=style&index=0&id=98b0ff50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98b0ff50",
  null
  
)

export default component.exports